import { MinusIcon } from "@/Icons/Minus";
import { Button } from "@/components/button";

import { ComponentProps } from "react";

import { twMerge } from "tailwind-merge";

type RemoveButtonButtonProps = Omit<
  ComponentProps<typeof Button>,
  "label" | "color"
>;

export const RemoveButton: React.FC<RemoveButtonButtonProps> = (props) => {
  return (
    <Button
      {...props}
      label={
        <MinusIcon
          height={16}
          width={16}
          fill={props.disabled ? "#948D8D" : "#000"}
        />
      }
      className={twMerge(
        "bg-grey1 hover:bg-grey2 flex h-8 w-8 min-w-0 items-center justify-center px-0",
        props.className,
      )}
    />
  );
};
